import * as Constants from '../constants';
import flatten from 'flat';

export function sendToGTM(eventObj) {
  if (!eventObj.eventDetails) {
    eventObj.eventDetails = {};
  }

  eventObj.event = 'custom-gtm-event';

  eventObj.eventDetails = {
    source: eventObj.source || Constants.OOC_SOURCE,
    source_url: window.location.pathname,
    platform: 'web',
    ...eventObj.eventDetails,
  };

  eventObj.eventDetails = JSON.stringify(flatten(eventObj.eventDetails));
  if (global.window && global.window.dataLayer) {
    window.dataLayer.push(eventObj);
  }
}